const BLOCK_TAG_PATTERN = /<\/\s*(p|div|li|ul|ol|h[1-6])\s*>/gi;
const LINE_BREAK_PATTERN = /<\s*br\s*\/?>/gi;
const UNSAFE_BLOCK_PATTERN = /<\s*(script|style)[^>]*>[\s\S]*?<\/\s*\1\s*>/gi;
const TAG_PATTERN = /<[^>]*>/g;
const WHITESPACE_PATTERN = /[ \t]+/g;

const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: ' ',
  quot: '"',
};

const decodeHtmlEntity = (entity: string): string => {
  const key = entity.toLowerCase();
  if (key in NAMED_ENTITIES) return NAMED_ENTITIES[key];

  if (key.startsWith('#x')) {
    const codePoint = Number.parseInt(key.slice(2), 16);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : `&${entity};`;
  }

  if (key.startsWith('#')) {
    const codePoint = Number.parseInt(key.slice(1), 10);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : `&${entity};`;
  }

  return `&${entity};`;
};

export const sanitizeLegalDisclaimer = (value: string | null | undefined): Array<string> =>
  (value ?? '')
    .replace(UNSAFE_BLOCK_PATTERN, '')
    .replace(LINE_BREAK_PATTERN, '\n')
    .replace(BLOCK_TAG_PATTERN, '\n')
    .replace(TAG_PATTERN, '')
    .replace(/&([a-z0-9#]+);/gi, (_match, entity: string) => decodeHtmlEntity(entity))
    .split('\n')
    .map((line) => line.replace(WHITESPACE_PATTERN, ' ').trim())
    .filter(Boolean);
